// extracted by mini-css-extract-plugin
export default {"root":"styles_root__Zvl9c","logo":"styles_logo__uO33l","link":"styles_link__MI+jk"};